import React, {useEffect,useState} from 'react';
import './App.css';
import Chat from './Chat';
import Sidebar from './Sidebar';
import uui from 'uuidv4'
import { api } from '../../../../package.json'
import Header from 'components/Headers/Header';
import useWebSocket from 'react-use-websocket';

function App(){
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setselectedMessage] = useState(null);
  const [sidebarToggle, setSidebarToggle] = useState(window.innerWidth >500 ? false : true);

  //const { lastJsonMessage, sendMessage } = useWebSocket('ws://127.0.0.1:55555/ws?test=whatsapp', {
  
  
  const { lastJsonMessage, sendMessage } = useWebSocket("wss://celebrationjump.com/ws?test=whatsapp", {
    onOpen: () => console.log(`Connected to App WS`),
    onMessage: (data) => {
      console.log(JSON.parse(data.data))
      setMessages(JSON.parse(data.data))
      
      const msgTemp = selectedMessage
      setselectedMessage(null)
      setselectedMessage(msgTemp)
      
      //console.log(data)
      if (lastJsonMessage) {
        console.log(lastJsonMessage);
      }
    },
    //queryParams: { 'token': '123456' },
    onError: (event) => { console.error(event); },
    shouldReconnect: (closeEvent) => true,
    reconnectInterval: 3000
  });
  
  useEffect(() => {


/*
      const socket = await new WebSocket('wss://celebrationjump.com/ws?test=whatsapp')
  
      await socket.onmessage((data)=>{
        setMessages(data)
        
        const msgTemp = selectedMessage
        setselectedMessage(null)
        setselectedMessage(msgTemp)
        
        console.log(data)
      })
      */

    
  }, []);
    return (
      <>
      <Header/>
      <div className="app" >
        <div className='app__body mt-2' style={{height:'100vh'}}>
          
          <Sidebar message={messages} sidebarToggleState={sidebarToggle} sidebarToggleSetState={setSidebarToggle} selectedMessage={setselectedMessage} style={{width:0}} key={uui}/>
        <Chat selectedMessage={selectedMessage} sidebarToggleState={sidebarToggle} sidebarToggleSetState={setSidebarToggle}/>
        </div>
      </div>
      </>
    )
}

export default App;
